import { FadeUp, Eyebrow, MaskedLines } from "@/components/Reveal";

const SectionTitle = ({ children }) => (
  <h2 className="font-serif text-xl sm:text-2xl text-[#F5F3EE]">{children}</h2>
);

const Para = ({ children }) => (
  <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#969696]">{children}</p>
);

const Strong = ({ children }) => <strong className="font-semibold text-[#F5F3EE]">{children}</strong>;

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-policy-page">
      <section className="relative overflow-hidden pt-32 pb-10 lg:pt-44 lg:pb-14 grain" data-testid="privacy-hero">
        <div className="pointer-events-none absolute -top-40 left-1/2 h-[480px] w-[720px] -translate-x-1/2 rounded-full bg-gold/[0.05] blur-[120px]" />
        <div className="relative mx-auto max-w-4xl px-6 sm:px-8">
          <FadeUp>
            <Eyebrow>Legale</Eyebrow>
          </FadeUp>
          <MaskedLines
            className="mt-6"
            delay={0.15}
            lineClassName="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#F5F3EE] tracking-tight"
            lines={[
              "Informativa sul Trattamento",
              <>
                dei <span className="gold-text gold-text-animated italic">Dati Personali.</span>
              </>,
            ]}
          />
          <FadeUp delay={0.4} className="mt-6">
            <p className="font-serif italic text-lg text-gold/90">Privacy Policy</p>
            <p className="mt-2 text-sm text-[#969696]">
              Ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR)
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="pb-16 lg:pb-24" data-testid="privacy-content">
        <div className="mx-auto max-w-4xl px-6 sm:px-8">
          <FadeUp className="border-t border-[#1A1A1A] pt-10">
            <SectionTitle>1. Titolare del Trattamento</SectionTitle>
            <Para>
              Il Titolare del trattamento dei dati è:
              <br />
              <Strong>Iconic Elite Management S.R.L.S.</Strong>
              <br />
              Sede legale: Via Martino Cilestri 71, 95127 Catania (CT)
              <br />
              P.IVA e C.F.: 06305130871 | R.E.A.: CT - 488773
              <br />
              PEC: iconic_elite@pec.it | Email: 1pietrolicandro@gmail.com
            </Para>
          </FadeUp>

          <FadeUp className="mt-10 border-t border-[#1A1A1A] pt-10">
            <SectionTitle>2. Tipologia di Dati Trattati e Finalità</SectionTitle>
            <ul className="mt-4 space-y-4">
              <li className="text-sm sm:text-base leading-relaxed text-[#969696]">
                <Strong>Dati di Navigazione:</Strong> I sistemi informatici acquisiscono, nel corso del loro normale
                esercizio, alcuni dati la cui trasmissione è implicita nell'uso dei protocolli di comunicazione
                Internet (es. indirizzi IP, tipo di browser, orari di accesso). Tali dati sono utilizzati al solo
                fine di ricavare informazioni statistiche anonime e per controllare il corretto funzionamento del
                sito.
              </li>
              <li className="text-sm sm:text-base leading-relaxed text-[#969696]">
                <Strong>Dati forniti volontariamente dall'utente:</Strong> L'invio facoltativo ed esplicito di
                messaggi tramite i canali di contatto presenti sul sito (email, WhatsApp) comporta l'acquisizione
                dei dati di contatto del mittente necessari per rispondere alle richieste, valutare eventuali
                candidature professionali come Creator o collaboratori e gestire l'interazione precontrattuale.
              </li>
            </ul>
          </FadeUp>

          <FadeUp className="mt-10 border-t border-[#1A1A1A] pt-10">
            <SectionTitle>3. Base Giuridica del Trattamento</SectionTitle>
            <Para>
              Il trattamento dei dati personali si fonda sull'esecuzione di misure precontrattuali o contrattuali
              adottate su richiesta dell'interessato (art. 6, par. 1, lett. b del GDPR) e sul legittimo interesse
              del Titolare a garantire la sicurezza del sito e rispondere alle comunicazioni ricevute (art. 6, par.
              1, lett. f del GDPR).
            </Para>
          </FadeUp>

          <FadeUp className="mt-10 border-t border-[#1A1A1A] pt-10">
            <SectionTitle>4. Modalità di Trattamento e Conservazione dei Dati</SectionTitle>
            <Para>
              I dati raccolti sono trattati nel rispetto dei principi di correttezza, liceità, trasparenza e tutela
              della riservatezza, con strumenti informatici e telematici. I dati saranno conservati per il tempo
              strettamente necessario a gestire le richieste dell'utente o per gli obblighi previsti dalla legge.
            </Para>
          </FadeUp>

          <FadeUp className="mt-10 border-t border-[#1A1A1A] pt-10">
            <SectionTitle>5. Comunicazione e Diffusione dei Dati</SectionTitle>
            <Para>
              I dati personali non saranno diffusi né ceduti a terzi per scopi promozionali. Possono essere trattati
              da soggetti autorizzati interni all'organizzazione o da fornitori di servizi tecnici e informatici
              strettamente connessi al funzionamento del sito web, formalmente vincolati al rispetto del segreto
              professionale e delle normative vigenti.
            </Para>
          </FadeUp>

          <FadeUp className="mt-10 border-t border-b border-[#1A1A1A] pt-10 pb-10">
            <SectionTitle>6. Diritti dell'Interessato</SectionTitle>
            <Para>
              In qualsiasi momento, l'utente può esercitare i propri diritti ai sensi degli artt. 15-22 del
              Regolamento UE 2016/679 (accesso, rettifica, cancellazione, limitazione, opposizione e portabilità)
              inviando una comunicazione scritta al Titolare all'indirizzo email{" "}
              <a href="mailto:1pietrolicandro@gmail.com" className="text-gold transition-colors hover:text-gold-bright">
                1pietrolicandro@gmail.com
              </a>{" "}
              o via PEC a{" "}
              <a href="mailto:iconic_elite@pec.it" className="text-gold transition-colors hover:text-gold-bright">
                iconic_elite@pec.it
              </a>
              . L'interessato ha altresì diritto di proporre reclamo all'Autorità Garante per la Protezione dei
              Dati Personali.
            </Para>
          </FadeUp>
        </div>
      </section>
    </main>
  );
}
